import { render, staticRenderFns } from "./web_setting.vue?vue&type=template&id=4ba762d3&"
import script from "./web_setting.vue?vue&type=script&lang=js&"
export * from "./web_setting.vue?vue&type=script&lang=js&"
import style0 from "./web_setting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports